export default "/fcbcac1db17390110677298f9d30eeed9c121039/a92d826d80900dda6092d3b109ffaee1.svg";